import { useMutation } from "@tanstack/react-query";
import { archiveResponse, ArchiveResponseProps } from ".";

export function useArchiveResponse() {
    return useMutation({
        mutationKey: ['response', 'archive'],
        mutationFn: async (props: ArchiveResponseProps) => {
            const res = await archiveResponse(props);
            return res;
        }
    })
}